module.exports = __webpack_public_path__ + "static/media/400286_01.90f0a346.png";